import Util from "@/lib/util";
export default [
  {
    title: Util.L("Client"),
    width: 120,
    key: "clientName",
  },
];
